

/////////////////////////////////////////////////////////////////////////
// TIME HELPERS /////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const CurrencyHelpers =  {

  CURRENCY_SYMBOLS: {
    'USD': '$'
  },
  currencyUnitDivisor: 1,
  currencyCode: 'USD',

  init: function(game) {

    this.game = game;  
  },
  

  getCashDisplayValue: function(amount, round, $commas) {

    var commas = (typeof $commas !== 'undefined') ? $commas : false;
    var currencySymbol = this.CURRENCY_SYMBOLS[this.currencyCode];
    var cashValue = amount / this.currencyUnitDivisor;
    var cashString = (round) ? Math.round(cashValue).toString() : cashValue.toFixed(2);

    // add commas
    if (commas) {
      cashString = PhaserUtils.StringUtils.insertNumberCommas(cashString);
    }

    return currencySymbol+cashString;

  }

};

export default CurrencyHelpers;




// WEBPACK FOOTER //
// ./app/src/utils/misc/CurrencyHelpers.js